import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import AcceptProposal from '../modules/AcceptProposal/main';

export const Route = createFileRoute('/accept-proposal/$token')({
  component: RouteComponent,
  params: z.object({
    token: z.string(),
  }),
});

function RouteComponent() {
  const { token } = Route.useParams();
  return <AcceptProposal token={token} />;
}
